<template>
  <div class="right-container" @click.stop="toggleDrawerRightMenu">
    <i class="el-icon-folder-checked" style="font-size:15px;top:8px" />
    <el-drawer
      title="任务列表"
      :visible.sync="drawerRightMenu"
      direction="rtl"
      :show-close="false"
      custom-class="drawer-right-menu"
      :append-to-body="true"
      :size="$global.isPC ? '40%' : '60%'"
      :before-close="toggleDrawerRightMenu"
    >
      <el-cascader
        v-model="route"
        class="filter-select"
        placeholder="请选择路由"
        :options="router"
        :props="{ value:'uri' }"
        clearable
        @change="searchList(1)"
      />
      <el-table
        v-loading="loading"
        :data="dataTask"
        borderc
        stripe
        :max-height="tableHeight"
        highlight-current-row
        :header-cell-style="{background:'#f5f7fa'}"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="路由名称"
          prop="route"
          width="300px"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ getRouteName(scope.row.route) }} - {{ scope.row.download_filename }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="创建时间"
          prop="create_time"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="文件大小"
          prop="file_size"
          width="80"
          show-overflow-tooltip
        />
        <el-table-column
          align="center"
          label="状态"
          prop="state"
          width="70"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.state === 0 ? '生成中': scope.row.state === 1 ? '完成' : scope.row.error_message }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button type="success" :disabled="scope.row.state !== 1 || !scope.row.file_size" @click="downloadFile(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="pagination.total"
        :total="pagination.total"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        style="margin-top:10px; text-align:right;"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
      />
    </el-drawer>
  </div>
</template>

<script>
import { exportFileList, gatAllRouterCascader } from '@/api/common'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      loading: false, // 数据加载
      dataTask: [], // 任务列表
      route: '', // 过滤条件
      pagination: { // 分页的一些参数
        total: 0, // 总条数
        page: 1, // 页码
        rows: 20
      },
      options: [],
      tableHeight: window.innerHeight - 220, // table自适应高度
      sTimeOut: null,
      router: []
    }
  },
  computed: {
    ...mapGetters([
      'permission_module'
    ]),
    drawerRightMenu() {
      // 是否打开抽屉
      return this.$store.state.app.drawerRightMenu
    }
  },
  watch: {
    drawerRightMenu(newValue, oldValue) {
      if (newValue) {
        this.searchList(this.pagination.page)
      } else {
        clearTimeout(this.sTimeOut)
      }
    }
  },
  created() {
    this.gatAllRouterCascader()
    if (this.drawerRightMenu) {
      this.searchList()
    }
  },
  mounted() {
    // table 最大高度 窗口一变化重新获取高度
    window.addEventListener('resize', () => { // 执行
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 220
      })
    })
  },
  methods: {
    /**
     * 切换是否打开抽屉
     */
    toggleDrawerRightMenu() {
      this.$store.dispatch('app/toggleDrawerRightMenu', !this.drawerRightMenu)
    },

    /**
     * 获取路由路径对应的名称
     * @param {String} route 路由路径
     * @return {String} 路由名称
     */
    getRouteName(route) {
      const name = this.options.filter(res => {
        return res.uri === route
      })[0]
      return name ? name.label : route
    },

    /**
     * 获取全部路由列表
     **/
    gatAllRouterCascader() {
      gatAllRouterCascader().then(response => {
        const module = []
        this.$global.modules.forEach(element => {
          module.push({
            label: element.name, module: element.value.toLowerCase()
          })
        })
        const router = []
        module.forEach(item => {
          const obj = {
            uri: item.module,
            label: item.label,
            value: item.module,
            children: []
          }
          response.data.route_cascader.forEach(_ => {
            if (_.module === item.module) {
              obj.children.push(_)
            }
          })
          router.push(obj)
        })

        this.router = router
        this.router.push({
          id: 10001,
          uri: '/admin',
          value: 1000,
          label: '管理员',
          children: [{
            id: 10001,
            uri: '/admin/log',
            value: 10001,
            label: '管理员日志'
          }]
        }, {
          id: 10086,
          uri: '/order',
          value: 10086,
          label: '其他',
          children: [{
            id: 1008611,
            uri: '/notice/alert-pay-data',
            value: 1008611,
            label: '首日回本预警'
          }]
        })
        this.options = []
        const setRouterLabel = (data) => {
          data.forEach(element => {
            if (element.module) {
              element.uri = '/' + element.module + element.uri
            }
            this.options.push(element)
            if (element.children && element.children.length > 0) {
              setRouterLabel(element.children)
            }
          })
        }
        setRouterLabel(this.router)
        for (let i = this.router.length - 1; i >= 0; i--) {
          if (this.router[i].children.length === 0) {
            this.router.splice(i, 1)
          } else if (this.$store.getters.super_manager !== 1 && this.router[i].label === '管理员') {
            this.router.splice(i, 1)
          } else if ((this.permission_module.length === 1 && this.permission_module[0] === 'fa') && this.router[i].label === '其他') {
            this.router.splice(i, 1)
          }
        }
      })
    },

    /**
     * 查询列表数据
     * @param {Number} page 页码
     */
    searchList(page) {
      this.loading = true
      const param = {
        route: this.route[this.route.length - 1],
        page: page, // 条数
        rows: this.pagination.rows // 页码
      }
      exportFileList(param).then((result) => {
        this.dataTask = result.data.list || []
        this.pagination.total = result.data.total
        clearTimeout(this.sTimeOut)
        if (this.drawerRightMenu) {
          this.sTimeOut = setTimeout(() => {
            this.searchList(this.pagination.page)
          }, 5000)
        }
      }).finally(res => {
        this.loading = false
      })
    },

    /**
     * 下载文件
     * @param {Number} id 文件ID1
     * @param {String} route 路由路径
     */
    downloadFile(data) {
      const sourceFilename = data.source_filename.split('/')
      if (sourceFilename[0] === 'upload') {
        const path = data.route_id === 169 ? this.$global.downloadDomain : ''
        this.exportTask(data.source_filename, null, path)
      } else {
        this.export('/common/exportFile', {
          id: data.id
        }, false, data.route)
      }
    },

    /**
     * 页码切换
     * @param {Number} page 目标页码
     */
    handleCurrentChange(page) {
      this.searchList(page)
    }
  }
}
</script>

<style lang="scss" scoped>
.right-container{
  float: left;
  line-height: 40px;
  width: 40px;
  text-align: center;
  height: 48px;
  cursor: pointer;
  i{
    position: relative;
    top: 6px;
  }
}
.right-container:hover{
  background: #F5F7FA;
}

</style>

<style lang="scss">
.drawer-right-menu{
  .el-drawer__header{
    background: #eef1f6;
    padding: 8px 24px;
    margin-bottom: 10px;
    border-radius: 2px;
    display: block;
    font-size: 14px;
    line-height: 32px;
  }
  .filter-select{
    margin-bottom: 10px;
    margin-left: 10px;
  }
  :focus {
    outline: -webkit-focus-ring-color auto 0px;
  }
}
@media  (max-height: 1000px) and (max-width: 1000px) {
  // 横屏时 时间控件留点位置可以触碰关闭
  .el-icon-folder-checked{
    top: 15%!important;
    font-size: 18px!important;
  }
}
@media  (max-width: 450px) {
  // 竖屏时 时间控件超出位置问题
  .el-icon-folder-checked{
    top: 15%!important;
    font-size: 18px!important;

  }
}

</style>
